import {createAction, props} from '@ngrx/store';
import {Organisation} from '@app/shared/models/organisation.model';

export const fetchOrganisations = createAction('[Organisation] Fetch Organisations');

export const fetchOrganisationsSuccess = createAction('[Organisation] Fetch Organisations Success', props<{response: Organisation[]}>());
